export default {
    addiction: 'اعتیاد',
    addictionTo: 'اعتیاد ',
    typesOfDrug: 'نوع ',
    duration: 'مدت(به ماه)',
}